<template>
	<main>
		<div class="common-report qtime-activity-view">
			<div>
				<div>
					<qtime-report-header></qtime-report-header>
				</div>
				<div>
					<qtime-activity-relation></qtime-activity-relation>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import QtimeActivityRelation from "./release-employee-month/ReleaseEmployeeMonth";
const QtimeReportHeader = () => import("./QtimeReportHeader");
export default {
  name: "QtimeActivity",
  components: { QtimeActivityRelation, QtimeReportHeader },
  computed: {
    // filter: function() {
    //   return this.$store.state.reports.qcentrisCountryTurnoverFilter;
    // }
  },
  beforeMount() {
    //this.fetchData();
  },
  methods: {
    // fetchData: function() {
    //   this.$store.dispatch("fetchCountryTurnover", this.filter);
    //   this.$store.dispatch("fetchReportAggregates");
    // }
  }
};
</script>

<style scoped>
	.qtime-activity-view {
		display: flex;
		display: -webkit-flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		-webkit-flex-wrap: wrap;
		-moz-flex-wrap: wrap;
	}
</style>
<style>
  .qtime-activity-view .table-row .position .vs__dropdown-toggle,
.qtime-activity-view .table-row .position .vs__dropdown-toggle .vs__actions,
.qtime-activity-view .table-row .position,
.qtime-activity-view .table-row .position .vs__selected-options,
.qtime-activity-view .table-row .position input{
    cursor: pointer;
}
.qtime-activity-view .vue-monthly-picker .month-year-display{
    padding-left: 15px;
}

.qtime-activity-view .table-row .col .select-wrapper .vs__actions{
    width: 40px!important;
}

</style>